import _ from 'lodash';

export default {
    computed: {
        typeConfig() {
            return { year: '年度報告及財務報表', quarter: '季度業績及財務報表', month: '每月營收公告' };
        },
        reportTypeOptions() {
            return _.chain(this.typeConfig)
                .map((value, key) => ({ value: key, text: value }))
                .value();
        },
    },
};
